<template>
  <div>
    <h2>Custom Label (SKU)</h2>
    <p class="text-muted mb-4">
      Controls how eShopCommand uses eBay's <strong>Custom Label (SKU)</strong> field when importing and grouping your listings.
    </p>
    <sku-uniqueness-setting :model-value="currentValue" @update:model-value="save" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import SkuUniquenessSetting from '@/app/components/Utils/SkuUniquenessSetting.vue'

const store = useStore()
const currentValue = computed(() => {
  const v = store.state.eshop.eshop?.config?.UNIQUE_SKU
  return v === null || v === undefined ? null : String(v)
})

function save(val) {
  store.dispatch('eshop/saveStoreConfig', { key: 'UNIQUE_SKU', val })
}
</script>
